/* eslint-disable prettier/prettier */
export const convertHoursToMinutes = ({ hours }) => hours * 60;
